import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import BryxColors from "../types/theme";
import withStaticMode from "../hocs/withStaticMode";
import { useState, useEffect } from "react";
const BryxInputHeader = withStaticMode(styled(({ initialValue, value, onChange, className, disabled, ...rest }) => {
    const [placeHolderText, setPlaceHolder] = useState(initialValue);
    const handleClose = () => {
        if (!Boolean(value.trim())) {
            onChange("");
            setPlaceHolder(initialValue);
        }
    };
    useEffect(() => {
        if (!Boolean(value.trim())) {
            setPlaceHolder(initialValue);
        }
    }, [value]);
    return (_jsx(TextField, { ...rest, disabled: disabled, fullWidth: true, type: "text", className: className, value: value, placeholder: placeHolderText, onFocus: () => setPlaceHolder(""), onBlur: handleClose, onChange: (e) => {
            onChange(e.currentTarget.value);
        }, variant: "standard", margin: "none", InputProps: { autoComplete: "off", disableUnderline: true } }));
})(({ theme, fontSize }) => ({
    caretColor: BryxColors.brandDark1(theme.palette.mode),
    "& .MuiInputBase-root": {
        fontSize: (fontSize ?? "25") + "px",
        input: {
            "&:hover:not(:focus)": {
                color: BryxColors.brandPrimary(theme.palette.mode),
            },
        },
    },
    "& .MuiInputBase-root:hover": {
        input: {
            "&::placeholder": {
                opacity: 1,
            },
        },
    },
})));
export default BryxInputHeader;
